export const userData = (users) =>
  users.map((user) => ({
    name: user.firstname,
    username: user.username,
    email: user.email,
    isActive: user.isActive === true ? "Active" : "Inactive",
  }));
